import { AUTHOR_CONTACT_TYPE } from "@/types/enum.ts";
import {
  AuthorContactBtnProps,
  getAuthorContactIconSrc,
} from "../home/article-list/ui/AuthorContactBtn";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React, { useState } from "react";
import { useTranslation } from "@/shared/hooks/useTranslation.tsx";
import { useModal } from "@/shared/ui/portal";
import "./showAuthorContactBtn.scss";

interface showAuthorContactBtnInterface {
  keyId: string;
  btnType: AuthorContactBtnProps[];
  productName?: string;
  dataSource?: string;
}

export const ShowAuthorContactBtn = (props: showAuthorContactBtnInterface) => {
  const [isOpenedAuthorDropDown, setIsOpenedAuthorDropDown] = useState(false);
  const { openSourceInfoModal } = useModal();
  const { t } = useTranslation();
  const url = window.location.href;

  const handleIsOpenedDropDown = (e: React.MouseEvent) => {
    e.stopPropagation();

    setIsOpenedAuthorDropDown((prev) => !prev);
  };

  const onClickLink = async (
    e: React.MouseEvent,
    btnType: AUTHOR_CONTACT_TYPE,
    link: string,
  ) => {
    e.stopPropagation();

    if (btnType === AUTHOR_CONTACT_TYPE.SOURCE_INFO) {
      openSourceInfoModal({
        productName: props.productName,
        dataSource: props.dataSource,
      });
      setIsOpenedAuthorDropDown(false);
      return;
    }

    if (btnType === AUTHOR_CONTACT_TYPE.EMAIL) {
      try {
        await navigator.clipboard.writeText(link);
        alert(t("contact.emailCopied"));
      } catch (err) {
        alert(t("contact.copyFailed"));
        console.log(err);
      }
    } else if (btnType === AUTHOR_CONTACT_TYPE.ARTICLE_LINK) {
      try {
        await navigator.clipboard.writeText(url + "detail/" + link);
        alert(t("contact.articleLinkCopied"));
      } catch (err) {
        alert(t("contact.copyFailed"));
        console.log(err);
      }
    } else {
      window.open(link, "_blank");
    }
  };

  return (
    <div className="show-author-contact-btn" key={props.keyId}>
      <div className="contact-menu-btn">
        <button
          className="drop-down-btn"
          onClick={(e) => handleIsOpenedDropDown(e)}
        >
          <img src={"/assets/icons/DotsThree.svg"} alt="drop-down" />
        </button>
      </div>
      {isOpenedAuthorDropDown ? (
        <div className="drop-down-list">
          <div
            key={`${props.keyId} source-info`}
            className="drop-down-element"
            onClick={(e) => onClickLink(e, AUTHOR_CONTACT_TYPE.SOURCE_INFO, "")}
          >
            <img
              src={`/assets/icons/${getAuthorContactIconSrc(AUTHOR_CONTACT_TYPE.SOURCE_INFO)}.svg`}
            />
            <div className="drop-down-text">
              {getAuthorContactText(AUTHOR_CONTACT_TYPE.SOURCE_INFO, t)}
            </div>
          </div>
          {props.btnType.map((prop: AuthorContactBtnProps) => {
            return (
              <div
                key={`${props.keyId} ${prop.btnType}`}
                className="drop-down-element"
                onClick={(e) => onClickLink(e, prop.btnType, prop.link)}
              >
                <img
                  src={`/assets/icons/${getAuthorContactIconSrc(prop.btnType)}.svg`}
                />
                <div className="drop-down-text">
                  {getAuthorContactText(prop.btnType, t)}
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

function getAuthorContactText(props: AUTHOR_CONTACT_TYPE, t: any) {
  switch (props) {
    case AUTHOR_CONTACT_TYPE.EMAIL:
      return t("contact.emailCopy");
    case AUTHOR_CONTACT_TYPE.INSTAGRAM:
      return t("contact.instagram");
    case AUTHOR_CONTACT_TYPE.LINKEDIN:
      return t("contact.linkedin");
    case AUTHOR_CONTACT_TYPE.ARTICLE_LINK:
      return t("contact.articleShare");
    case AUTHOR_CONTACT_TYPE.SOURCE_INFO:
      return t("contact.sourceInfo");
  }
}
